<script lang="ts" module>
  import { X } from 'phosphor-svelte';

  export interface MiniCartProps {
    /** Custom CSS styles for the component. */
    css?: SystemStyleObject;
    header?: Snippet;
    footer?: Snippet;
    content?: Snippet;
  }
</script>

<script lang="ts">
  import type { Snippet } from "svelte";
  import type { SystemStyleObject } from "@agapi/ui/panda/types";
  import { css } from "@agapi/ui/panda/css";
  import { miniCartStyles } from "./minicart.styles";
  import { stack } from "@agapi/ui/panda/patterns";

  const { css: cssProp, header, footer, content }: MiniCartProps = $props();

  const classes = miniCartStyles.raw();
</script>

<div class={css(classes.root, cssProp)}>
  {@render header?.()}
  <div class={stack({ pb: 7 })}>
    {@render content?.()}
  </div>
  {@render footer?.()}
</div>
